export enum CalcType {
  Amount = 'amount',
  Savings = 'savings',
}
